<template>
	<div v-loading="loading" class="base_scroll_page">
		<div class="b_scroller">
			<!-- action -->
			<div style="font-size: 0;text-align: right;">
				<el-button type="primary" @click="handleRefreshClick">刷新</el-button>
			</div>
			<!-- action end -->
			
			<!-- 表格 -->
			<div class="base_table" style="margin-top: 20px;">
				<el-table
					:data="list"
					style="width: 100%"
				>
					<el-table-column
						prop="platName"
						label="登录平台"
					>
					</el-table-column>
					<el-table-column
						prop="num"
						label="当前登录人数"
					>
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->
		</div>
	</div>
</template>

<script>
	import Api from '../../../../api/index.js';
	
	export default {
		mounted() {
			this.getData();
		},
		data() {
			return {
				loading: false,
				list: []
			}
		},
		methods: {
			/*********************** @Events ****************************/
			// 点击刷新
			handleRefreshClick() {
				this.list = [];
				this.getData();
			},
			
			/*********************** @Function ****************************/
			// 获取数据
			getData() {
				const that = this;
				that.loading = true;
				Api.findLoginCount().then((res) => {
					that.loading = false;
					if (res.data.success) {
						res.data.data.forEach(v => {
							that.list.push({
								num: v.num || 0,
								platName: v.typeName || ''
							});
						});
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			}
		}
	}
</script>

<style scoped>
</style>
